import { facadeApi } from 'api'

export interface UserToInviteData {
  email: string
  firstname: string
  lastname: string
  groupsMembership: string[]
  isExternal: boolean
}

interface Params {
  data: UserToInviteData
  tenantId: string
}

export const inviteNewUserApi = ({ data, tenantId }: Params) =>
  facadeApi.post('users/invite', data, {
    headers: {
      'X-Tenant-Prefix': tenantId,
    },
  })
